import api from '../../services/api';

const formatString = (str) => str.replace(/ /g, "+");

const performSearch = async (title, author, setBooks, setIsActive, setError) => {
    if (!title.trim()) return;

    if (typeof setError === 'function') setError(null);

    try {
        const params = new URLSearchParams({ title, language: 'fr', startIndex: 0, maxResults: 30 });
        if (author) params.append('author', author);

        const response = await api.get(`/searchGoogleBooks?${params}`);

        if (response.data.error) {
            if (typeof setError === 'function') setError(response.data.error);
            setBooks([]);
        } else {
            setBooks(response.data.items || []);
            if (typeof setIsActive === 'function') setIsActive(true);
        }
    } catch (error) {
        const message = error.response?.data?.error ?? 'Search unavailable. Please try again.';
        if (typeof setError === 'function') setError(message);
        else console.error("Failed to fetch books:", error);
    }
};

const handleGoogleSearch = async (event, setBooks, setIsActive, setError) => {
    if (event.key === 'Enter') {
        const title = event.target.form ? event.target.form.search.value : event.target.value;
        const author = event.target.form ? event.target.form.author.value : null;
        await performSearch(title, author, setBooks, setIsActive, setError);
    }
};

export { handleGoogleSearch, performSearch, formatString };
